<app-header [logged]="false"  ></app-header>


<div class="container mt-5">
    <div *ngFor="let note of noteList">
      <h1>{{note.title}}</h1>
      <div class=" ql-snow" style="border-width: 0;">
        <div class="ql-editor" [innerHTML]='note.inner_html | safeUserHtml'></div>
      </div>
      <app-youtube-video video_id = '{{note.youtube_id}}' ></app-youtube-video>
    </div>
  </div>


